import websiteTypes from './websites.types';

export const fetchWebsitesStart = () => ({
  type: websiteTypes.FETCH_WEBSITES_START,
});

export const fetchWebsitesStartSuccess = (data) => ({
  type: websiteTypes.FETCH_WEBSITES_START_SUCCESS,
  payload: data,
});

export const fetchWebsitesStartFailure = (error) => ({
  type: websiteTypes.FETCH_WEBSITES_START_FAILURE,
  payload: error,
});

export const setWebsites = (websites) => ({
  type: websiteTypes.SET_WEBSITES,
  payload: websites,
});

export const loadingWebsites = () => ({
  type: websiteTypes.LOADING_WEBSITES,
});

export const addNewContainerStart = (website) => ({
  type: websiteTypes.ADD_NEW_CONTAINER_START,
  payload: website,
});

export const addNewWebsiteStart = (website) => ({
  type: websiteTypes.ADD_NEW_WEBSITE_START,
  payload: website,
});

export const toggleWebsiteStatusStart = (website) => ({
  type: websiteTypes.TOGGLE_WEBSITE_STATUS_START,
  payload: website,
});

export const assignOperatorsStart = (credentials) => ({
  type: websiteTypes.ASSIGN_OPERATORS_START,
  payload: credentials,
});

export const addNewWebsite = (website) => ({
  type: websiteTypes.ADD_NEW_WEBSITE,
  payload: website,
});

export const SetWebsiteStatus = (website) => ({
  type: websiteTypes.SET_WEBSITE_STATUS,
  payload: website,
});

export const setCurrentWebsite = (websiteId) => ({
  type: websiteTypes.SET_CURRENT_WEBSITE,
  payload: websiteId,
});

export const updateWebsiteOperatorList = (selectedOperatorsIds) => ({
  type: websiteTypes.UPDATE_WEBSITE_OPERATOR_LIST,
  payload: selectedOperatorsIds,
});

export const fetchWhatsappBarcodeStart = (payload) => ({
  type: websiteTypes.FETCH_WHATSAPP_BARCODE_START,
  payload: payload,
});

export const loadingWhatsappBarcode = () => ({
  type: websiteTypes.LOADING_WHATSAPP_BARCODE,
});

export const setWhatsappBarcode = ({ barcode, alreadyLoggedIn }) => ({
  type: websiteTypes.SET_WHATSAPP_BARCODE,
  payload: { barcode, alreadyLoggedIn },
});

export const logoutWhatsapp = (payload) => ({
  type: websiteTypes.LOGOUT_WHATSAPP,
  payload: payload,
});

export const setPermissionWhatsapp = (permission) => ({
  type: websiteTypes.SET_PERMISSION_WHATSAPP,
  payload: permission,
});

export const updateContainerTeam = (team) => ({
  type: websiteTypes.UPDATE_CONTAINER_TEAM,
  payload: team,
});

export const sendContainersTeam = (containersTeam) => ({
  type: websiteTypes.SEND_CONTAINERS_TEAM,
  payload: containersTeam,
});

export const setChannelsTeam = (channelsTeam) => ({
  type: websiteTypes.SET_CHANNELS_TEAM,
  payload: channelsTeam,
});

export const setAgentAssignByUrl = (assign) => ({
  type: websiteTypes.SET_AGENT_ASSIGN_BY_URL,
  payload: assign,
});

export const sendGroupMessage = (formData, loadingSubmitHandle) => ({
  type: websiteTypes.SEND_GROUP_MESSAGE,
  payload: { formData, loadingSubmitHandle },
});

export const sendWhatsappGroupMessage = (formData, loadingSubmitHandle) => ({
  type: websiteTypes.SEND_WHATSAPP_GROUP_MESSAGE,
  payload: { formData, loadingSubmitHandle },
});

export const deleteWebsite = (channelID) => ({
  type: websiteTypes.DELETE_WEBSITE,
  payload: channelID,
});

export const deleteWebsiteSuccess = (channelID) => ({
  type: websiteTypes.DELETE_WEBSITE_SUCCESS,
  payload: channelID,
});

export const deleteWebsiteFailure = (error) => ({
  type: websiteTypes.DELETE_WEBSITE_FAILURE,
  payload: error,
});

export const setSelectedWorkspace = (selectedWebsiteObj) => ({
  type: websiteTypes.SET_SELECTED_WORKSPACE,
  payload: selectedWebsiteObj,
});

export const resetWebsitesState = () => ({
  type: websiteTypes.RESET_WEBSITES_STATE,
});
